var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWriteReviewHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6226 36.5387C19.8812 36.5387 18.7102 35.7704 18.1971 35.2573C17.156 34.2161 15.6991 33.6485 14.4558 32.9233C12.2039 31.6097 10.2692 28.9514 8.67805 26.9624C8.00112 26.1163 7.34145 25.3447 6.77882 24.3882C5.86834 22.8404 4.35329 20.3822 4.35329 18.5189C4.35329 17.1495 3.94141 15.7258 3.94141 14.2971C3.94141 12.9868 4.2928 12.1494 4.57067 10.899C4.88858 9.46846 6.96031 6.15484 8.67805 6.05941C9.92436 5.99017 11.1821 5.85347 12.488 5.85347C13.5142 5.85347 14.7921 6.41372 15.886 6.47129C16.5952 6.50862 18.5155 7.44137 18.9751 8.01585C19.4223 8.57478 20.2307 8.76013 20.6226 9.446C20.7986 9.75394 21.2085 10.1165 21.4464 10.3842C22.0998 11.1192 22.4278 12.1202 22.6706 12.9699C22.681 13.0062 22.6889 13.0586 22.6948 13.1203C22.7476 12.3841 22.9599 11.6639 23.2541 11.002C25.1198 6.80426 28.6641 4 33.288 4C34.5435 4 36.949 6.20735 37.2924 7.40947C37.8258 9.27635 38.5395 11.2527 38.5395 13.3703V17.2832C38.5395 18.3279 37.7924 19.2277 37.7158 20.2236C37.6713 20.8011 36.8652 22.1564 36.5259 22.5805C36.2587 22.9144 36.1389 23.4667 35.7593 23.7703C35.0407 24.3453 34.7206 25.4154 34.0546 26.0815C32.2923 27.8437 30.8845 29.8427 28.8145 31.2758C27.5932 32.1213 26.6333 33.6613 25.2563 34.2733C24.3576 34.6728 21.483 36.1085 20.6226 36.5387Z",
    fill: "#FF8CBD",
    stroke: "#FF8CBD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWriteReviewHeart);
export default __webpack_public_path__ + "static/media/icon-write-review-heart.b1ef8d056d6fdecde8a09e9fd8f6306a.svg";
export { ForwardRef as ReactComponent };